if(!customElements.get('popup-modals')) {
  class PopupModals extends HTMLElement {
    constructor() {
      super();

      this.delay = Number(this.getAttribute('delay'));

      this.elSection = this.closest('.shopify-section');
      this.elPopups = this.querySelectorAll('popup-modal:not(.preferences-popup)');
      this.elClose = this.querySelectorAll('[data-close]');
      this.elClose.forEach(el => el.addEventListener('click', this.closeActivePopup.bind(this)));

      this.activePopup = null;

      if(!Shopify.designMode) {
        setTimeout(() => this.setActivePopup(), this.delay);
      } else {
        document.addEventListener('shopify:section:select', ({ detail }) => {
          let sectionId = `shopify-section-${detail.sectionId}`;
          this.elSection && this.elSection.id == sectionId ? this.classList.add('active') : this.classList.remove('active');
        });
      };

      this.cookieNames = [...this.elPopups].map(el => el.getAttribute('data-id'));
      window.debugPopupCookies = () => this.cookieNames.forEach(name => {
        window.storageAvailable() && localStorage.removeItem(name)
      });
    }

    setActivePopup() {
      for(let popup of this.elPopups) {
        const cookieName = popup.getAttribute('data-id');
        const hasCookie = window.storageAvailable() ? !!localStorage.getItem(cookieName) && localStorage.getItem(cookieName) !== "false" : false;
        
        if(!hasCookie) {
          popup.setAttribute('open', true);
          this.classList.add('active');
          this.activePopup = popup;
          break;
        }
      }
    }

    closeActivePopup() {
      const cookieName = this.activePopup.getAttribute('data-id');
      const expiration = Number(this.activePopup.getAttribute('data-expiration'));
      
      this.activePopup.setAttribute('open', false);

      setTimeout(() => {
        window.setStorageItem(cookieName, 'true', expiration);
        this.classList.remove('active');
        this.activePopup = null;
      }, 300);
    }
  }

  customElements.define('popup-modals', PopupModals);
}